import React, { useState } from 'react';
import { ChevronLeft as SelectIcon } from '@td-client-frontend/icons';
import clsx from 'clsx';
import { trackEvent } from '../api/piwik/piwikService';
import { PiwikCategory, PiwikAction, PiwikName } from '../@types/common';

export function SideMenu({ children }) {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSideMenu = () => {
    trackEvent({
      category: PiwikCategory.BUTTONS,
      action: PiwikAction.CLICKED,
      name: PiwikName.SEARCH_HIDE
    });
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="flex self-stretch h-auto max-h-screen transition-all duration-150 shadow-lg pl-7"
      style={{ minWidth: '400px', marginLeft: !isOpen ? '-360px' : '0px' }}
      aria-expanded={isOpen}
    >
      <div className="relative flex flex-col w-full mb-20 mr-3" hidden={!isOpen} id="side-menu">
        {children}
      </div>
      <button
        className="flex flex-col justify-start w-8 ml-auto cursor-pointer focus:outline-none focus-visible:ring"
        onClick={toggleSideMenu}
        aria-label={isOpen ? 'Close Search Panel' : 'Open Search Panel'}
        aria-controls="side-menu"
        aria-expanded={isOpen}
      >
        <span className={clsx(!isOpen && 'rotate-180', 'duration-200 transform')}>
          <SelectIcon className="w-5 h-5" />
        </span>
      </button>
    </div>
  );
}
